import { relations } from 'drizzle-orm'
import { index, jsonb, pgTable, text } from 'drizzle-orm/pg-core'
import {
  getBaseFields,
  getBaseIndexes,
  getDateField,
  getNullableIdReference,
  getTimestampWithTimezone,
} from '../common/utils'
import { users } from './user'

export const paymentImportRuns = pgTable(
  'payment_import_runs',
  {
    ...getBaseFields(),
    source: text().notNull(),
    status: text().notNull(),
    windowFrom: getDateField().notNull(),
    windowTo: getDateField().notNull(),
    startedAt: getTimestampWithTimezone().notNull().defaultNow(),
    finishedAt: getTimestampWithTimezone(),
    latestBookedDate: getDateField(),
    parseResult: jsonb(),
    importResult: jsonb(),
    skipped: jsonb(),
    error: text(),
    triggeredByUserId: getNullableIdReference(() => users.id),
  },
  (table) => [
    ...getBaseIndexes('payment_import_runs', table),
    index('payment_import_runs_started_at_idx').on(table.startedAt),
  ],
)

export const paymentImportRunsRelations = relations(
  paymentImportRuns,
  ({ one }) => ({
    triggeredByUser: one(users, {
      fields: [paymentImportRuns.triggeredByUserId],
      references: [users.id],
    }),
  }),
)
